export default __webpack_public_path__ + "static/media/aragon.5130da09.png";